import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';

export class VisitorService {


    static async createVisitor(data={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/visitor/create`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async hasClient(doc, email, phone) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/auth/hasClient?doc=${doc}&email=${email}&phone=${phone}`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }



}